/**
 * Permission identifiers used by the backend to gate access to admin features.
 *
 * The backend ships an array of permission strings inside the login response
 * (encoded + gzipped + base64 — see src/utils/permissions.ts for decoding).
 * The frontend mirrors this same enforcement for UX, but the backend remains
 * the source of truth: every admin endpoint independently re-validates these.
 */
export const PERMISSIONS = {
  CHATBOT_ADMIN: 'Permissions.Chatbot.Admin',
} as const;

export type Permission = typeof PERMISSIONS[keyof typeof PERMISSIONS];
